import { AuxiliumComponent } from "../auxilium-component";

export default class CarouselSlide extends AuxiliumComponent {
	static observableBooleans = ["active"];

	attributeChanged(name, _, newValue) {
		if (name === "active") {
			if (this.IsAttributeValueTrue(newValue) && !this.active) {
				[...this.parentElement.parentElement?.querySelectorAll(":scope > li > chip-carouselslide") ?? []]
					.forEach(x => x.active = x === this);
			}

			this.closest("chip-carousel")?.querySelector(".carousel__slide-list")?.scrollTo({ left: this.parentElement.offsetLeft, behavior: "smooth" });
		}
	}
}
